const tokenConfig = getState => { 
  //Setup config/headers and token
  //Get Token from Redux State
  const token = getState().authToken;
  const config = {
    headers: {
      "Content-Type": "application/json"
    }
  };

  //If Token, add to headers
  if(token) config.headers['x-auth-token'] = token;
  return config;
};

export default tokenConfig;